import { render, staticRenderFns } from "./FloatingCommentInput.vue?vue&type=template&id=32c5e302&scoped=true"
import script from "./FloatingCommentInput.vue?vue&type=script&lang=ts"
export * from "./FloatingCommentInput.vue?vue&type=script&lang=ts"
import style0 from "./FloatingCommentInput.vue?vue&type=style&index=0&id=32c5e302&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5e302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c5e302')) {
      api.createRecord('32c5e302', component.options)
    } else {
      api.reload('32c5e302', component.options)
    }
    module.hot.accept("./FloatingCommentInput.vue?vue&type=template&id=32c5e302&scoped=true", function () {
      api.rerender('32c5e302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Comments/FloatingCommentInput.vue"
export default component.exports